import React, { Component } from 'react';
import ReactDOM from "react-dom";
import { loadModules } from 'esri-loader';
class CBasemapGallery extends Component {
    constructor(props) {
        super(props); 
        this.state =  { 
            view: this.props.view
        } 
        this.startup(
            this.props
        ); 
    }  
   
     
    startup = (config) => {
        loadModules([
            "esri/core/watchUtils",
            "esri/widgets/BasemapGallery",
            "esri/widgets/Expand"
        ]).then(([watchUtils,BasemapGallery, Expand]) => {
            try{
                const basemapGallery = new BasemapGallery({
                    view: config.view
                });
    
                this.basemapcontainer = ReactDOM.findDOMNode(this);
                const basemapExpand = new Expand({
                    collapseTooltip: "Collapse Basemap Gallery",
                    expandTooltip: "Expand Basemap Gallery",
                    view: config.view,
                    content: basemapGallery,
                    container: this.basemapcontainer
                }); 
                config.view.ui.add(basemapExpand, "top-right");
                this.props.widgetRenderCallBack("BasemapGallery")
                const inThis = this;
                watchUtils.pausable(basemapExpand, "expanded", function (newValue, oldValue) { 
                    inThis.props.onexpanded(basemapExpand, newValue);
                });
            }catch(ex){
              console.log(ex);
            }
        });
    }
     

  render() {
    return (
        <div className="BasemapGallery-box" style={{order:this.props.order}}>
          
        </div>
    );
  }
}

export default CBasemapGallery;